<template>
  <transition name="toast">
    <div v-if="visible" class="br-toast" :class="`br-toast--${type}`">
      <div class="br-toast__stripe" />
      <v-icon class="br-toast__icon" :color="cfg.color" size="20">{{ cfg.icon }}</v-icon>
      <span class="br-toast__msg">{{ msg }}</span>
      <v-btn icon x-small class="br-toast__close" @click="close">
        <v-icon size="16" color="#9B9BAA">mdi-close</v-icon>
      </v-btn>
    </div>
  </transition>
</template>

<script>
const CFG = {
  error:   { icon: 'mdi-alert-circle-outline', color: '#FF5252' },
  success: { icon: 'mdi-check-circle-outline', color: 'var(--v-success-base)' },
  warning: { icon: 'mdi-alert-outline',        color: '#FFC107' },
  info:    { icon: 'mdi-information-outline',  color: '#2196F3' },
}

export default {
  name: 'BrSnackbar',
  props: {
    snackbar: {
      type: Object,
      default: () => ({ toggle: false, type: 'success', msg: '' })
    }
  },
  data () {
    return { visible: false, type: 'success', msg: '', timer: null }
  },
  computed: {
    cfg () { return CFG[this.type] || CFG.info },
  },
  watch: {
    snackbar: {
      deep: true,
      handler (val) {
        if (val.toggle) this.show(val.type, val.msg)
      }
    }
  },
  methods: {
    show (type, msg) {
      this.type = type || 'info'
      this.msg = msg
      this.visible = true
      clearTimeout(this.timer)
      this.timer = setTimeout(this.close, 5000)
    },
    close () { this.visible = false },
  },
  beforeDestroy () { clearTimeout(this.timer) },
}
</script>

<style lang="scss" scoped>
.br-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #1D1D29;
  border-radius: 12px;
  padding: 14px 18px 14px 20px;
  min-width: 320px;
  max-width: 560px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.07);

  &__stripe {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 12px 0 0 12px;
  }

  &__icon {
    flex-shrink: 0;
  }

  &__msg {
    flex: 1;
    font-size: 13px;
    color: #E0E0E0;
    line-height: 1.5;
  }

  &__close {
    flex-shrink: 0;
  }

  &--error   .br-toast__stripe { background: #FF5252; }
  &--success .br-toast__stripe { background: var(--v-success-base); }
  &--warning .br-toast__stripe { background: #FFC107; }
  &--info    .br-toast__stripe { background: #2196F3; }
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.25s ease, transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.toast-enter,
.toast-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-20px);
}
</style>
